import { render, staticRenderFns } from "./GroupMemberRequestsModal.vue?vue&type=template&id=7e0734d2&"
import script from "./GroupMemberRequestsModal.vue?vue&type=script&lang=js&"
export * from "./GroupMemberRequestsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports